import { combineReducers } from '@reduxjs/toolkit';
import authReducer from 'redux/authReducer';

export default combineReducers({
  auth: authReducer,
});
